import React, {ReactElement} from "react";

import Image, {ImageObject} from "../../image/Image";
import SimpleFormWrapper from "../../forms/simple-form-wrapper/SimpleFormWrapper";
import {SimpleFormProps} from "/src/types";

import {css} from "/src/utils/utils";

import * as styles from "./widget-form.module.scss";

interface WidgetFormProps {
  body?: string;
  form?: SimpleFormProps;
  headline?: string;
  image?: ImageObject;
}

const WidgetForm = (props: WidgetFormProps): ReactElement | null => {
  const {body, form, headline, image} = props;

  if (!body && !form && !headline && !image) {
    return null;
  }

  return (
    <section className={css("widget-base", styles.widgetForm)}>
      {image && (
        <Image
          objectFit="cover"
          image={image}
          classes={styles.widgetForm__img}
        />
      )}

      {headline && (
        <h4 className={css("h4", styles.widgetForm__headline)}>{headline}</h4>
      )}

      {body && <p className={css("p", styles.widgetForm__body)}>{body}</p>}

      {form && (
        <SimpleFormWrapper
          {...form}
          darkMode
          disableResize
          layout="full"
          transparentBg
          contentClasses={styles.widgetForm__form}
        />
      )}
    </section>
  );
};

export default WidgetForm;
